module.exports = __webpack_public_path__ + "static/img/delete-icon-w.96eed0b1.svg";